<div *ngIf="fieldConfig" [formGroup]="fieldConfig.formGroup" class="field">
  <label [for]="fieldConfig.formControlName">{{fieldConfig.label}}</label>
  <input [id]="fieldConfig.formControlName" [type]="fieldConfig.type" [formControlName]="fieldConfig.formControlName">
  <p *ngIf="isSubmit && fieldConfig.errorMessage && fieldConfig.formGroup?.get(fieldConfig.formControlName)?.errors" class="error">{{fieldConfig.errorMessage}}</p>
</div>